import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../styles/AdminUsers.css";

export default function AdminUsers() {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const filteredUsers = users.filter(user =>
    `${user.id} ${user.name} ${user.lastname1} ${user.email} ${user.phone}`
        .toLowerCase()
        .includes(search.toLowerCase())
    );

  useEffect(() => {
    loadUsers();
  }, []);

  const loadUsers = async () => {

    const response = await fetch(
      "/api/admin/users",
      {
        credentials: "include",
      }
    );

    if (response.ok) {
      setUsers(await response.json());
    }
  };

  return (
    <main className="admin-page">
      <section className="admin-users">
        <button
          className="admin-back-btn"
          onClick={() => navigate("/admin")}
        >
          ← {t("adminUsers.backToDashboard")}
        </button>
        <h1>{t("adminUsers.title")}</h1>
        <div className="admin-toolbar">
            <input
                type="text"
                placeholder={t("adminUsers.searchPlaceholder")}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
        </div>
        <table>
          <thead>
            <tr>
              <th>{t("adminUsers.name")}</th>
              <th>{t("adminUsers.email")}</th>
              <th>{t("adminUsers.phone")}</th>
              <th>{t("adminUsers.roles")}</th>
              <th>{t("adminUsers.status")}</th>
              <th>{t("adminUsers.actions")}</th>
            </tr>
          </thead>

          <tbody>
            {filteredUsers.length === 0 ? (
                <tr>
                <td colSpan="6" className="admin-empty">
                    {t("adminUsers.empty")}
                </td>
                </tr>
            ) : (
                filteredUsers.map(user => (
                <tr key={user.id}>
                    <td>
                    {user.name} {user.lastname1}
                    </td>

                    <td>{user.email}</td>

                    <td>{user.phone}</td>

                    <td>
                    {user.roles?.map(role => (
                        <span
                        key={role}
                        className="role-badge"
                        >
                        {role}
                        </span>
                    ))}
                    </td>

                    <td>
                    <span
                        className={
                        user.enabled
                            ? "status-active"
                            : "status-disabled"
                        }
                    >
                        {user.enabled ? t("adminUsers.active") : t("adminUsers.disabled")}
                    </span>
                    </td>

                    <td>
                    <button
                        className="admin-action-btn"
                        onClick={() => navigate(`/admin/users/${user.id}`)}
                    >
                        {t("adminUsers.view")}
                    </button>
                    </td>
                </tr>
                ))
            )}
            </tbody>
        </table>

      </section>
    </main>
  );
}